import { Link } from '@tanstack/react-router';

export function NotFoundScreen() {
  return (
    <section className="flex flex-col items-center gap-3 rounded-[11px] border border-border bg-card px-8 py-[52px] text-center">
      <h2 className="text-[15px] font-semibold text-foreground">Page not found</h2>
      <p className="max-w-[440px] text-[13px] leading-[1.55] text-muted-foreground">
        That URL does not match any screen in the console.
      </p>
      <Link
        to="/"
        className="mt-1 flex h-8 items-center rounded-[7px] border border-border bg-card px-3.5 text-[12.5px] font-medium text-foreground no-underline hover:bg-accent"
      >
        Back to overview
      </Link>
    </section>
  );
}
